import React from "react";
import PropTypes from "prop-types";
import { defaultTemplate } from "core/hoc";
import { BaasicFieldDropdown, BaasicButton, BaasicDropdown, BaasicModal, BasicInput, BaasicDraggableModal } from "core/components";
import { Button } from "@progress/kendo-react-buttons";
import { observer } from "mobx-react";
import { FacilityOrderTemplateItemNewFlowNoteModal } from "application/facility-order-new-flow/components";
import { NikoPatientTemplateItemCalculationModal } from "application/niko-patient/components";
import { NikoFacilityOrderConfirmationModal } from "application/niko-facility-order/components";
import { Tooltip as ReactTooltip } from "react-tooltip";

const NikoNewPatientTemplateCreateTemplate = function ({ nikoTemplateCreateViewStore, disabled, showDnsTag, cssClass, tableClass, onRemove }) {
    const {
        form,
        subCategoryStore,
        patientTemplateItems,
        nikoPatientTemplateItemCalculationModal,
        facilityOrderTemplateItemNewFlowNoteModal,
        disabledTable,
        patientTemplateTrachItems,
        isSystemDns,
        isUserDns,
        missingProductNote,
        isAddingNote,
        missingProductNoteModal,
        doNotSupplyModal,
        pageType,
    } = nikoTemplateCreateViewStore;

    const isUSIorCR = pageType === 'USI' || pageType === 'CR';

    return (
        <React.Fragment>
            <div className={`u-flex--default u-flex--space-between ${cssClass}`}>
                <div className="u-flex u-flex--align-end u-flex--gap--1">
                    <div className="form__group w--200--px">
                        <BaasicFieldDropdown field={form.$('subCategoryId')} store={subCategoryStore} disabled={disabled || disabledTable} />
                    </div>
                    {isUserDns && (
                        <div className="u-mar--left--tny btn--disc__wrapper is-fr">
                            Do not supply - FR
                            <Button className="btn btn--disc" onClick={() => { doNotSupplyModal.open({ icon: "over-circle", title: "Unmark As Do Not Supply", description: "Are you sure you want to unmark this order as Do Not Supply?", action: () => { nikoTemplateCreateViewStore.isUserDns = false; doNotSupplyModal.close(); } }); }} disabled={disabled}>
                                <i className="u-icon u-icon--xxsml u-icon--close--neg"></i>
                            </Button>
                        </div>
                    )}
                    {showDnsTag && isSystemDns && (
                        <div className="u-mar--left--tny btn--disc__wrapper is-fr">Do not supply</div>
                    )}
                    {isUSIorCR && missingProductNote && (
                        <Button className="btn btn--status--red u-mar--left--tny is-alg" icon="u-icon u-icon--med-lrg u-icon--missing-product" onClick={() => { missingProductNoteModal.open(); }} disabled={disabled} />
                    )}
                </div>
                
                {!pageType && (
                    <div className="form__group">
                        <BasicInput field={form.$('note')} disabled={disabled || disabledTable} />
                    </div>
                )}
                {pageType && (
                    <div className="form__group u-align--h--right col is-dnsfr">
                       
                        <div className="btngroup">
                            {isUSIorCR && !missingProductNote && (
                                <React.Fragment>
                                    <ReactTooltip positionStrategy="fixed" id={"questionnote"} place="bottom" />
                                    <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--us-question-note" data-tooltip-content="Missing Product Note" data-tooltip-id={"questionnote"} onClick={() => { missingProductNoteModal.open(); }} disabled={disabled} />
                                </React.Fragment>
                            )}
                            {isUSIorCR && !isUserDns && (
                                <React.Fragment>
                                        <ReactTooltip positionStrategy="fixed" id={"dns"} place="bottom" />
                                        <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--do-not-supply" data-tooltip-content="Mark As Do Not Supply" data-tooltip-id={"dns"} onClick={() => { doNotSupplyModal.open({ icon: "over-circle", title: "Mark As Do Not Supply", action: () => { nikoTemplateCreateViewStore.isUserDns = true; doNotSupplyModal.close(); } }); }} disabled={disabled} />
                                </React.Fragment>
                            )}
                            {!form.$('note').value && (
                                <React.Fragment>
                                        <ReactTooltip positionStrategy="fixed" id={"note"} place="bottom" />
                                        <Button className="btn no-hover" icon="u-icon u-icon--med-lrg u-icon--danger-triangle--primary" data-tooltip-content="Add Note" data-tooltip-id={"note"} onClick={() => { nikoTemplateCreateViewStore.isAddingNote = true; }} disabled={disabled} />
                                </React.Fragment>
                            )}
                            {onRemove && (
                                <React.Fragment>
                                    <ReactTooltip positionStrategy="fixed" id={"deletetemplate"} place="bottom" />
                                    <Button className="btn no-hover" icon="u-icon u-icon--med u-icon--delete--brand" data-tooltip-content="Delete Template" data-tooltip-id={"deletetemplate"} onClick={onRemove} disabled={disabled} />
                                </React.Fragment>
                            )}
                        </div>
                    </div>
                )}
            </div>
            {pageType && (isAddingNote || form.$('note').value) && (
                <div className="u-mar--top--tny u-mar--bottom--sml c-message has-input u-flex--default w--100 c-message--note--primary">
                    <i className="u-icon u-icon--sml u-icon--danger-triangle" />
                    <input
                        className="input input--sml input--message u-flex--grow--1 type--sml"
                        placeholder="Enter Intake Changes Note"
                        autoFocus={isAddingNote}
                        value={form.$('note').value || ''}
                        onChange={(e) => { form.$('note').set('value', e.target.value); }}
                        onBlur={() => {
                            // Clear the transient "adding note" flag on blur so it doesn't persist and
                            // re-trigger autoFocus when this step is remounted (e.g. navigating back from summary).
                            // The field stays visible on its own whenever a note value exists.
                            nikoTemplateCreateViewStore.isAddingNote = false;
                        }}
                        disabled={disabled}
                    />
                </div>
            )}
            <div className="table--tertiary__wrapper u-mar--bottom--sml">
                <TemplateItemsTable nikoTemplateCreateViewStore={nikoTemplateCreateViewStore} patientTemplateItems={patientTemplateItems} disabled={disabled} tableClass={tableClass} />
            </div>
            {patientTemplateTrachItems.length > 0 &&
                <div className="table--tertiary__wrapper">
                    <TemplateItemsTable nikoTemplateCreateViewStore={nikoTemplateCreateViewStore} patientTemplateItems={patientTemplateTrachItems} disabled={disabled} tableClass={tableClass} />
                </div>
            }
            <BaasicDraggableModal modalParams={nikoPatientTemplateItemCalculationModal} className="modal__content modal--lrg">
                <NikoPatientTemplateItemCalculationModal />
            </BaasicDraggableModal>
            <BaasicModal modalParams={facilityOrderTemplateItemNewFlowNoteModal} className="modal__content modal--med">
                <FacilityOrderTemplateItemNewFlowNoteModal />
            </BaasicModal>
            <BaasicDraggableModal modalParams={doNotSupplyModal} className="modal__content modal--med">
                <NikoFacilityOrderConfirmationModal />
            </BaasicDraggableModal>
            <BaasicDraggableModal modalParams={missingProductNoteModal} className="modal__content modal--med">
                <NoteModal
                    title="Missing Product Note"
                    placeholder="Enter Missing Product Note"
                    value={missingProductNote || ''}
                    onChange={(val) => { nikoTemplateCreateViewStore.missingProductNote = val; }}
                    onResolve={() => { nikoTemplateCreateViewStore.missingProductNote = ''; missingProductNoteModal.close(); }}
                    onClose={() => missingProductNoteModal.close()}
                />
            </BaasicDraggableModal>
        </React.Fragment>
    );
};

const TemplateItemsTable = observer(({ nikoTemplateCreateViewStore, patientTemplateItems, disabled, tableClass }) => {
    const {
        patientTemplateTrachItems,
        productStore,
        itemCategory,
        saveItem,
        editItem,
        deleteItem,
        openNikoPatientTemplateItemCalculationModal,
        disabledTable,
    } = nikoTemplateCreateViewStore;

    const productDropdownItemRender = (li, itemProps) => {
        const itemName = itemProps && itemProps.dataItem.description;
        const isPreferredIcon = itemProps && itemProps.dataItem.isPreferred && itemCategory === "ostomy" ?
            <i className="u-icon u-icon--xsml u-icon--star-outlined u-mar--right--tny"></i> : null;
        const isBackorderedIcon = itemProps && itemProps.dataItem.backordered ? <i className="u-icon u-icon--sml u-icon--backordered u-mar--left--tny"></i> : null;
        const nonBillableIcon = itemProps && !itemProps.dataItem.billableToMedicare ? <i className="u-icon u-icon--sml u-icon--non-billable u-mar--left--tny"></i> : null;
        const itemChildren = (
            <span style={{ display: "flex", flexDirection: "column", width: "100%", }}>
                <span style={{ flex: "1" }}> {li.props.children} </span>
                <span style={{ fontSize: "12px" }}> {isPreferredIcon} {itemName} {nonBillableIcon} {isBackorderedIcon}</span>
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    }

    const isEnteral = itemCategory === "enteral" && patientTemplateItems !== patientTemplateTrachItems;

    return (
        <table className={`table table--tertiary ${tableClass}`}>
            <colgroup>
                <col className="cell--condition--id" />
                <col className="cell--condition--name" />
                <col className="cell--condition--uom" />
                <col className="cell--condition--qty" />
                <col className="cell--condition--note"/>
                <col className="cell--condition--actions" />
            </colgroup>
            <thead>
                <tr>
                    <th>Item Id</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>QTY</th>
                    <th>NOTE</th>
                    <th className="type--right">Actions</th>
                </tr>
            </thead>
            <tbody>
                {patientTemplateItems.map((item, index) => {
                    let isFormula = (item && item.product && item.product.itemType && (item.product.itemType.abrv === 'bottle' || item.product.itemType.abrv === 'can')) || (item.product && item.product.procedureCode_ && item.product.procedureCode_.abrv === "B4155");
                    return (
                        <tr key={index}>
                            <td>
                                {
                                    item.product ? item.product.itemId :
                                        <BaasicDropdown
                                            placeholder="Select an ID..."
                                            store={productStore}
                                            value={item.product}
                                            itemRender={productDropdownItemRender}
                                            onChange={(e) => { saveItem(patientTemplateItems, index, e.target.value); }}
                                            disabled={disabled || disabledTable}
                                        />
                                }
                            </td>
                            <td className="is-flex">
                                {item.product && item.product.description} <span className="table__icons-wrapper"> {item.product && !item.product.billableToMedicare && <i className="u-icon u-icon--sml u-icon--non-billable"></i>} {(item.backordered != null ? item.backordered : item.product && item.product.backordered) && <i className="u-icon u-icon--med-lrg u-icon--backordered"></i>}</span>
                            </td>
                            <td>
                                {item.product && item.product.unitOfMeasure ? item.product.unitOfMeasure.name : (item.product && item.product.uoM)}
                            </td>
                            <td className="table-col-input text-align-left">
                                <input
                                    className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                    onClick={(e) => e.target.select()}
                                    onChange={(e) => {
                                        editItem(patientTemplateItems, index, e.target.value, 'quantity')
                                    }}
                                    value={item.quantity || item.quantity === 0 ? item.quantity : undefined}
                                    type="number"
                                    min="0"
                                    disabled={disabled || disabledTable}
                                />
                            </td>
                            <td>
                                {isEnteral && isFormula ?
                                    <input
                                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                        onClick={() => openNikoPatientTemplateItemCalculationModal(patientTemplateItems, index)}
                                        value={item.note}
                                        readOnly={true}
                                    /> :
                                    <input
                                        className="input--table input--inherit-color no-arrows input--text-align--left w--70--px"
                                        onClick={(e) => e.target.select()}
                                        onChange={(e) => { item.note = e.target.value }}
                                        value={item.note}
                                        disabled={disabled || disabledTable}
                                    />
                                }
                            </td>
                            <td className="type--right">
                                <div className="table__icons">
                                    {
                                        item.product &&
                                        <BaasicButton
                                            className="btn btn--icon"
                                            icon="u-icon u-icon--delete--primary u-icon--sml"
                                            label="Delete"
                                            onlyIcon={true}
                                            onClick={() => deleteItem(patientTemplateItems, index)}
                                            disabled={disabled || disabledTable}
                                        ></BaasicButton>
                                    }
                                </div>
                            </td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
});

TemplateItemsTable.propTypes = {
    nikoTemplateCreateViewStore: PropTypes.object.isRequired,
    patientTemplateItems: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    tableClass: PropTypes.string
};

const NoteModal = ({ title, placeholder, value, onChange, onResolve, onClose }) => {
    const [noteValue, setNoteValue] = React.useState(value);

    return (
        <div>
            <div className="modal__header">
                <h3 className="modal__header__title">{title}</h3>
            </div>
            <div className="modal__body">
                <div className="form__group u-mar--bottom--sml">
                    <textarea
                        className="input input--med input--textarea"
                        placeholder={placeholder}
                        value={noteValue}
                        onChange={(e) => setNoteValue(e.target.value)}
                        rows={4}
                        autoFocus
                    />
                </div>
            </div>
            <div className='modal__footer'>
                {onResolve && (
                    <BaasicButton
                        className='btn btn--med btn--light'
                        label='Resolve'
                        rotate
                        icon="u-icon u-icon--xmed u-icon--check"
                        onClick={onResolve}
                    />
                )}
                <BaasicButton className='btn btn--med btn--primary' label='Save' onClick={() => { onChange(noteValue); onClose(); }} />
            </div>
        </div>
    );
};

NoteModal.propTypes = {
    title: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onResolve: PropTypes.func,
    onClose: PropTypes.func
};

NikoNewPatientTemplateCreateTemplate.propTypes = {
    nikoTemplateCreateViewStore: PropTypes.object.isRequired,
    disabled: PropTypes.bool,
    showDnsTag: PropTypes.bool,
    cssClass: PropTypes.string,
    tableClass: PropTypes.string,
    onRemove: PropTypes.func
};

export default defaultTemplate(NikoNewPatientTemplateCreateTemplate);
